// extracted by mini-css-extract-plugin
module.exports = {"active":"carousel_active__vLTaT","inactive":"carousel_inactive__4u_A_"};